import { Col, InputGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import { SendDocumentIconSVG } from 'src/Admin/img/uploadDocument/uploadDocumentSVG';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import TextInput from 'src/Components/GenericInputText/TextInput';
import CustomPaginationItemsDisplay from '../../common/pagination/CustomPaginationItemsDisplay';
import CustomPagination from '../../common/pagination';
import DocumentListTable from '../../uploaddocument/DocumentTable/DocumentListTable';
import useDocuments from './hooks/useDocuments';
import useUploadDocument from '../../uploaddocument/hooks/useUploadDocument';
import AutoSuggestionSelectComponent from 'src/Member/components/common/auto-suggestion-select/Select';
import DocumentType from '../../uploaddocument/DocumentTypeData/DocumentType';
import ViewDocumentListSkeleton from './../../uploaddocument/skeleton/ViewDocumentListSkeleton';

const DocumentIndex = () => {
  const {
    typeOptionList,
    docType,
    setDocType,
    docTypeMeta,
    resetDocType,
    setResetDocType,
    physicianType,
    setPhysicianType,
    selectedDocTypeData,
    setSelectedDocTypeData,
    loadLocation,
    setLoadLocation,
    locationTypeMeta,
    selectedLocationData,
    setSelectedLocationData,
    defaultLocationloader,
    setDefaultLocationloader,
    defaultValueskeletonLoader,
    setDefaultValueSkeletonLoader,
  } = useUploadDocument();

  const {
    filteredRecords,
    pageSize,
    currentPage,
    totalRecords,
    searchText,
    columnNames,
    displayPaginationMininumCount,
    pageSizeHandler,
    paginationHandler,
    onSearch,
    skeletonLoader,

    setCurrentPage,
    setTypeData,
    typeData,
    selectDocType,
    documentListNoDataError,
  } = useDocuments({
    selectedDocTypeData,
    selectedLocationData,
    docType,
    physicianType,
    setDocType,
  });

  //temparary changes to remove Eligibility and claims from dropdown in Document list page : Admin center
  const filteredTypeOptionList = typeOptionList?.filter(
    (item) =>
      !(
        item?.label?.includes('Eligibility') || item?.label?.includes('Claims')
      ),
  );
  console.log('typeOptionList--@', typeOptionList);
  return (
    <div className="document_Index_Container">
      <div
        className={`documents-filter-containerr filter-bar-border-top mt-3 ${
          docType === undefined && `filter-bar-border-bottom`
        }`}
      >
        <div className="search-container-filter">
          <Row className="justify-content-between">
            <Col
              xs={12}
              sm={6}
              md={8}
              lg={5}
              className=" border-right-documents py-3"
            >
              <label htmlFor="filterByTitleReference" className="sr-only">
                Search by title
              </label>
              <TextInput
                parentClassName="document-search"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'Search by Title',
                  className: 'border-0 height-32 mr-1',
                  value: searchText,
                  onChange: onSearch,
                  id: 'filterByTitleReference',
                }}
              />
            </Col>
            <Col lg={2} md={2} className="Sort_by_option px-0 py-3 pl-3">
              <div className="filter-data1 d-flex gap-3 align-items-center">
                <div>
                  <span className="dropdown_label">Type:</span>
                </div>
                <div className="type_category_select">
                  <AutoSuggestionSelectComponent
                    options={filteredTypeOptionList}
                    components={{ IndicatorSeparator: () => null }}
                    value={docType}
                    onChange={(e) => {
                      setDocType(e);
                      setResetDocType(true);
                      setSelectedDocTypeData();
                      setSelectedLocationData();
                      setLoadLocation(false);
                      setDefaultLocationloader(false);
                      //setCurrentPage(1);
                      //setTypeData(e);
                    }}
                    isSearchable={false}
                    inputClassName="height-32"
                    aria-labelledby="forsortby"
                  />
                </div>
              </div>
            </Col>

            <Col
              xs={12}
              sm={6}
              md={4}
              lg={5}
              className="send-document-button py-4"
            >
              <div className="d-flex justify-content-end">
                <div
                  className="messaging-reset pr-4"
                  onClick={() => {
                    selectDocType(true);
                    setSelectedLocationData();
                  }}
                >
                  Reset Filter
                </div>
                <Link to="/admin/upload-document" state={{ userSpecDoc: true }}>
                  <GenericButton
                    variant="primary"
                    tabIndex={0}
                    ariaLabel="Click to go to send document screen"
                  >
                    <span className="mr-2">
                      <SendDocumentIconSVG />
                    </span>
                    Send Document
                  </GenericButton>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {!(docType === undefined) &&
        !['CLAIM', 'DEPENDENT'].includes(docType.value) && (
          <div className="documents-filter-containerr filter-bar-border-top filter-bar-border-bottom ">
            <div className="document-specific-search-container-filter pl-4 py-3">
              <DocumentType
                docTypeMeta={docTypeMeta}
                docType={docType}
                resetDocType={resetDocType}
                setResetDocType={setResetDocType}
                physicianType={physicianType}
                setPhysicianType={setPhysicianType}
                selectedDocTypeData={selectedDocTypeData}
                setSelectedDocTypeData={setSelectedDocTypeData}
                loadLocation={loadLocation}
                setLoadLocation={setLoadLocation}
                locationTypeMeta={locationTypeMeta}
                selectedLocationData={selectedLocationData}
                setSelectedLocationData={setSelectedLocationData}
                defaultLocationloader={defaultLocationloader}
                setDefaultLocationloader={setDefaultLocationloader}
                defaultValueskeletonLoader={defaultValueskeletonLoader}
                setDefaultValueSkeletonLoader={setDefaultValueSkeletonLoader}
                displayFirstRecord={true}
                providerFieldAlignment={
                  docType.value === 'PHYSICIAN' ||
                  docType.value === 'CONNECTOR' ||
                  docType.value === 'FACILITY'
                    ? 'horizontal'
                    : 'verticle'
                }
              />
            </div>
          </div>
        )}

      <div>
        <div className="container-offset">
          <div className="d-flex justify-content-between mt-4 pl-2 pagination-container">
            {totalRecords > displayPaginationMininumCount ? (
              <CustomPaginationItemsDisplay
                pageSize={pageSize}
                setPageSize={pageSizeHandler}
                prefixMessage="Records per page"
                suffixMessage={`Showing ${
                  currentPage * pageSize - pageSize + 1
                } - ${
                  pageSize * currentPage < totalRecords
                    ? pageSize * currentPage
                    : totalRecords
                } of ${totalRecords} results`}
              />
            ) : null}

            <div className="d-flex align-items-center">
              {totalRecords > displayPaginationMininumCount ? (
                <CustomPagination
                  className="p-0 m-0"
                  pageSize={pageSize}
                  currentPage={currentPage}
                  totalCount={totalRecords}
                  onPageChange={paginationHandler}
                />
              ) : null}
            </div>
          </div>
          {skeletonLoader ? (
            <ViewDocumentListSkeleton />
          ) : (
            <div className="document-list-table-admin mt-4 ml-2">
              <DocumentListTable
                className="account-table"
                //preserveData={props.preserveData}
                columns={columnNames}
                data={filteredRecords}
                keyField={columnNames}
                pageSizeCount={pageSize}
                userSpecDoc={true}
                docType={docType}
                selectedDocTypeData={selectedDocTypeData}
                physicianType={physicianType}
                docTypeMeta={docTypeMeta}
                selectedLocationData={selectedLocationData}
                documentListNoDataError={documentListNoDataError}
                searchText={searchText}
                initialSortBy={{
                  id: 'SentDate',
                  desc: true,
                }}
              />
            </div>
          )}
          <div className="d-flex justify-content-between mt-4 pagination-container-2">
            {totalRecords > displayPaginationMininumCount ? (
              <CustomPaginationItemsDisplay
                pageSize={pageSize}
                setPageSize={pageSizeHandler}
                prefixMessage="Records per page"
              />
            ) : null}

            <div className="d-flex align-items-center">
              {totalRecords > displayPaginationMininumCount ? (
                <CustomPagination
                  className="p-0 m-0"
                  pageSize={pageSize}
                  currentPage={currentPage}
                  totalCount={totalRecords}
                  onPageChange={paginationHandler}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentIndex;
